import { createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
    name: 'app',
    initialState: {
        online: window.navigator.onLine,
        autoconnect: -1,
        disabled: false,
    },
    reducers: {
        online: (state, action) => {
            state.online = true;
        },
        offline: (state, action) => {
            state.online = false;
        },
        autoconnect: (state, action) => {
            if (action.payload === true) {
                state.autoconnect = -1;
            } else if (action.payload === false) {
                state.autoconnect = 0;
            } else {
                state.autoconnect = action.payload;
            }
        },
        disabled: (state, action) => {
            state.disabled = !!action.payload;
            if (!action.payload && state.autoconnect && window.navigator.onLine) {
                state.online = true;
            }
        }
    }
});

export const online = (dispatch) => {
    dispatch(appSlice.actions.online({}));
}
export const offline = (dispatch) => {
    dispatch(appSlice.actions.offline({}));
}
export const setAutoconnect = (dispatch, state) => {
    dispatch(appSlice.actions.autoconnect(state));
}
export const setDisabled = (dispatch, state) => {
    dispatch(appSlice.actions.disabled(!!state));
}
export const selectOnline = state => state.app.online;
export const selectDisabled = state => state.app.disabled;
export const selectAutoconnect = state => state.app.autoconnect;

const reducerDetails = { name: appSlice.name, reducer: appSlice.reducer };
export default reducerDetails;